module.exports = __webpack_public_path__ + "img/ico_dm_2.27b2d0ad.png";